import React, { useEffect, useRef } from "react"
import PropTypes from 'prop-types'
import { styled, getAccessibleTextColor } from "../../utilities";
import modules from './bubble.module.scss';
import { OSU_CHAT_ARIA_REGION } from "../../utilities/constants";

const StyledBubble = styled.div`
  ${({ $backgroundColor, $color, $borderColor }) => {
      return {
        backgroundColor: $backgroundColor,
        color: $color ? $color : $backgroundColor ? getAccessibleTextColor($backgroundColor) : '',
        border: `1px solid ${$borderColor}`
    }
  }}
`;

const Bubble = (props) => {
    const { className, alignment, senderLabel, children, backgroundColor, color, borderColor, focus, outline, ...rest } = props
    const ref = useRef()

    useEffect(() => {
        if(focus) {
          turnOffAria() //Should occur before focusing
          ref?.current && ref.current.focus()
        }
    }, [focus])
    
    const turnOffAria = () => {
      const ariaRegion = document.getElementById(OSU_CHAT_ARIA_REGION);
      if (ariaRegion instanceof Element) {
        const currentAttribute =
          ariaRegion && ariaRegion.getAttribute("aria-live");
        if (currentAttribute === "polite") {
          ariaRegion.setAttribute("aria-live", "off");
        }
      }
    };

    const handleBlur = (e) => {
      const currentTarget = e.currentTarget;
      const ariaRegion = document.getElementById(OSU_CHAT_ARIA_REGION);
      setTimeout(() => {
        if (
          !currentTarget.contains(document.activeElement) &&
          ariaRegion instanceof Element
        ) {
          const currentAttribute = ariaRegion.getAttribute("aria-live");
          if (currentAttribute === "off") {
            ariaRegion.setAttribute("aria-live", "polite");
          }
        }
      }, 0);
    };

    return <StyledBubble onBlur={handleBlur} tabIndex={focus ? -1 : undefined} ref={ref} $backgroundColor={backgroundColor} $color={color} $borderColor={borderColor} className={`${modules.bubble} ${alignment === 'right' ? 'ml-auto' : ''} ${className}`.trim()} {...rest}>
        {senderLabel && <AccessiblePhrase phrase={senderLabel} />}
        {children}
    </StyledBubble>
}

const AccessiblePhrase = ({ phrase = '' }) => {
    if (typeof phrase !== 'string') return phrase

    return <span className="sr-only">{phrase}&nbsp;</span>
}

Bubble.defaultProps = {
    alignment: 'left',
    className: '',
    outline: false
}

Bubble.propTypes = {
    alignment: PropTypes.oneOf(['left', 'right']),
    backgroundColor: PropTypes.string,
    border: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    outline: PropTypes.bool,
    senderLabel: PropTypes.node
}

export default Bubble